// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "c09cb2734abd1086e5a9ea490c90966c130b8add/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};